<template>
    <v-app theme="light" style="background-color: #eeeeee">
        <nav-bar-risk/>

        <VMain>
            <breadcrumbs />
            <router-view class="secondary--text" />
        </VMain>
        <test-error />
        <orixe-footer/>
    </v-app>
</template>

<script>
export default {}
</script>

<style>
</style>